import { CustomFilterConfig, CustomFilterContent, CustomFilterSectionType } from 'components/CruiseSearchWidget/types';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { useAppContext } from 'contexts/appContext';
import { CUSTOM_FILTERS_KEY, ListFilter } from 'lib/apiClient';
import React, { useMemo } from 'react';
import { FilterOptions } from '../FilterOptions/FilterOptions';

interface CustomFilterProps {
	sectionsToRender?: CustomFilterSectionType[];
}

export const CustomFilter: React.FC<CustomFilterProps> = ({ sectionsToRender }) => {
	const { dictionary } = useAppContext();
	const { filters, activeFilter, filterKeyToCustomFilterConfig, featureFlags } = useFiltersContext();
	const { enableRiverCruises } = featureFlags;

	const customFilters = useMemo(() => {
		if (!activeFilter) return [];

		const allCustomFilters = filters?.find(({ key }) => key === CUSTOM_FILTERS_KEY);
		const customFilterConfig: CustomFilterConfig = filterKeyToCustomFilterConfig[activeFilter.key];

		if (!allCustomFilters || !customFilterConfig) return [];

		const { container, labelDictionaryKey, sections } = customFilterConfig;

		const customFilterOptions = (allCustomFilters as ListFilter).options.filter((option) => option.containers?.includes(container));

		const filterOptionsBySection = (section: CustomFilterSectionType) => {
			const filterOptions = customFilterOptions.filter((option) => {
				if (option.section?.includes(section) || (section === CustomFilterSectionType.Default && !option.section)) {
					return true;
				}
				return false;
			});
			return filterOptions;
		};

		const customFilters: CustomFilterContent[] = [];

		if (sections && sections.length > 0) {
			sections.forEach((section) => {
				if (sectionsToRender && !sectionsToRender.includes(section.section)) {
					return;
				}
				if (!enableRiverCruises && section.section === CustomFilterSectionType.River) {
					return;
				}
				const filterOptions = filterOptionsBySection(section.section as CustomFilterSectionType);
				if (filterOptions.length) {
					customFilters.push({
						customFilterLabel: dictionary[section.labelDictionaryKey],
						filterOptions,
					});
				}
			});
		} else {
			const filterOptions = filterOptionsBySection(CustomFilterSectionType.Default);
			if (filterOptions.length) {
				customFilters.push({
					customFilterLabel: dictionary[labelDictionaryKey ?? 'labelCustomFilter'],
					filterOptions,
				});
			}
		}
		return customFilters;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeFilter, filters, dictionary]);

	return (
		<>
			{customFilters.length > 0 &&
				customFilters.map((customFilter) => (
					<FilterOptions
						key={customFilter.customFilterLabel}
						isUniqueFilter={true}
						label={customFilter.customFilterLabel}
						options={customFilter.filterOptions}
						filterKey={CUSTOM_FILTERS_KEY}
					/>
				))}
		</>
	);
};
